// extracted by mini-css-extract-plugin
export var bgDark = "form-module--bgDark--cCuom";
export var button = "form-module--button--thKyg";
export var contact = "form-module--contact--va4PV";
export var contactUs = "form-module--contactUs--ejLK8";
export var error = "form-module--error--VYmDM";
export var primary = "form-module--primary--H8GoF";
export var states = "form-module--states--DYmrO";
export var submitted = "form-module--submitted--WGcQ+";